<div class="TotemWidget TotemWidgetIdentity {{fullScreen ? 'TotemWidgetIdentity--FullScreen' : 'TotemWidgetIdentity--' + size.toUpperCase() }} card">
    <div class="card-body">
        @if (image) {
            <div class="TotemWidgetIdentity-Image me-3">
                <img class="border border-primary" [src]="image" [alt]="name || ('totem-a11y.logo' | locTranslate)"/>
            </div>
        }
        <div>
            @if (name) {
                <h4 class="TotemWidgetIdentity-Name card-title mb-2">
                    <span>{{name}}</span>
                </h4>
            }
            @if (providedBy) {
                <div class="TotemWidgetIdentity-ProvidedBy text-muted mb-3">
                    {{ providedBy }}
                </div>
            }
            @if (hasContacts) {
                <div class="TotemWidgetIdentity-Contacts d-flex flex-wrap gap-2">
                    @if (emailHref) {
                        <a class="btn btn-primary" target="_blank" rel="noopener noreferrer" [href]="emailHref">
                            <i class="fa-regular fa-envelope me-2" aria-hidden="true"></i>
                            <span>{{ 'totem-widget-identity.email' | locTranslate }}</span>
                            <span class="visually-hidden"> {{ 'totem-a11y.opens-new-window' | locTranslate }}</span>
                        </a>
                    }
                    @if (phoneHref) {
                        <a class="btn btn-primary" [href]="phoneHref">
                            <i class="fa-regular fa-phone me-2" aria-hidden="true"></i>
                            <span>{{ 'totem-widget-identity.phone' | locTranslate }}</span>
                        </a>
                    }
                </div>
            }
        </div>
    </div>
</div>
